import React, { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { formatNumber } from './Utils';
import goldImage from '../images/gold.png';
import { useMediaQuery } from 'react-responsive';
import $ from 'jquery';
import config from '../config';

const Nav = ({ title, subtitle }) => {
  const [gold, setGold] = useState(0);
  const dropdownRef = useRef(null);
  const location = useLocation();
  const twitchData = localStorage.getItem("twitchData");
  const displayName = twitchData ? JSON.parse(twitchData).display_name : null;
  const isMobile = useMediaQuery({ maxWidth: 768 });

  useEffect(() => {
    const fetchGold = async () => {
      const accessToken = localStorage.getItem("twitchToken");
      if (!accessToken) {
        return;
      }

      try {
        const response = await fetch(`${config.serverURL}/getinventory`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            jwt: null,
            accessToken: accessToken,
          }),
        });

        if (!response.ok) {
          throw new Error('Failed to fetch gold');
        }

        const data = await response.json();
        setGold(data.user.stats.gold);
      } catch (error) {
        console.error('Error fetching gold:', error);
      }
    };

    fetchGold();
    //const intervalId = setInterval(fetchGold, 5000);

    //return () => clearInterval(intervalId);
  }, []);

  const handleLogout = (event) => {
    event.preventDefault();
    localStorage.removeItem("twitchToken");
    localStorage.removeItem("twitchData");
    localStorage.removeItem("characterId");
    window.location.href = "/";
  };

  const navItems = [
    { name: 'Home', path: '/' },
    { name: 'Listings', path: '/listings' },
    { name: 'My Listings', path: '/listings/me' },
    { name: 'History', path: '/history' },
  ];

  const handleSelectChange = (event) => {
    const selectedItem = navItems.find(item => item.path === event.target.value);
    if (selectedItem && selectedItem.onClick) {
      selectedItem.onClick(event);
    } else {
      window.location.href = event.target.value;
    }
  };

  useEffect(() => {
    const handleCustomDropdownClick = (event) => {
      const dropdownItems = $('.rpgui-dropdown-imp li').toArray();
      const clickedItemIndex = dropdownItems.indexOf(event.target);
      if (clickedItemIndex !== -1) {
        const selectedItem = navItems[clickedItemIndex];
        if (selectedItem && selectedItem.onClick) {
          selectedItem.onClick(event);
        } else {
          window.location.href = selectedItem.path;
        }
      }
    };

    $(document).on('click', '.osrpg-nav .rpgui-dropdown-imp li', handleCustomDropdownClick);

    return () => {
      $(document).off('click', '.osrpg-nav .rpgui-dropdown-imp li', handleCustomDropdownClick);
    };
  }, [navItems]);

  useEffect(() => {
    if (isMobile && dropdownRef.current && !dropdownRef.current.initialized) {
      dropdownRef.current.initialized = true;
      if (window.RPGUI) {
        window.RPGUI.create(dropdownRef.current, "dropdown");
        dropdownRef.current.className = '';
      }
    }
  }, [isMobile]);

  const isLoggedIn = localStorage.getItem("twitchToken") && localStorage.getItem("twitchData") && localStorage.getItem("characterId");
  
  if (isLoggedIn) {
    navItems.push({ name: 'Logout', path: '/logout', onClick: handleLogout });
  }

  return (
    <header className="osrpg-header">
      <h1>
        <a href="/">{title}</a>
      </h1>
      <div className={`header-content ${isMobile ? 'mobile' : ''}`}>
        <nav className="osrpg-nav">
          {isMobile ? (
            <div style={{ display: isMobile ? 'block' : 'none' }}>
              <select onChange={handleSelectChange} ref={dropdownRef}>
                {navItems.map(item => (
                  <option key={item.name} value={item.path}>
                    {item.name}
                  </option>
                ))}
              </select>
            </div>
          ) : (
            <ul className="nav-list">
              {navItems.map(item => (
                <li key={item.name}>
                  <a
                    href={item.path}
                    onClick={item.onClick}
                    className={location.pathname === item.path ? 'active' : ''}
                  >
                    {item.name}
                  </a>
                </li>
              ))}
            </ul>
          )}
        </nav>
        {displayName && (
          <div className="user-info">
            <div className="welcome">
              <p>Welcome, {displayName}!</p>
              <div className="gold-content">
                <img className="small-image" src={goldImage} alt="gold"/>
                <p>{formatNumber(gold)}</p>
              </div>
            </div>
          </div>
        )}
      </div>
      <hr className="golden" />
      <br />
      <h2 className="subtitle">{subtitle}</h2>
    </header>
  );
};

export default Nav;